import createIframe from './threeds2utilities/iframe';
import createForm from './threeds2utilities/form';
import base64URL from './threeds2utilities/base64url';
import { challengeWindowSizes } from './threeds2utilities/config';
export var getChallengeIframe = _ref => {
  var {
    acsURL,
    payload,
    iframeConfig,
    callback,
    API
  } = _ref;
  var iframeSizeCode = iframeConfig && iframeConfig.size ? iframeConfig.size : '01'; // Defaults to 250 x 400

  var iframeSize = challengeWindowSizes[iframeSizeCode];
  var iframeName = 'threeDSIframe';

  if (iframeConfig) {
    if (iframeConfig.container instanceof HTMLElement === false) throw new Error('A container for the challenge iframe has not been specified or is not an HTMLElement');
    if (iframeConfig.container instanceof HTMLIFrameElement) iframeName = iframeConfig.container.getAttribute('name') || '';
    var jsonStr = JSON.stringify(payload);
    var base64EncodedcReqData = base64URL.encode(jsonStr);
    return new Promise(function (resolve) {
      var appendAndSubmitForm = iframe => {
        function messageHandler(event) {
          if (API.startsWith(event.origin)) {
            var _event$data, _event$data$transStat;

            resolve({
              transStatus: (_event$data = event.data) == null ? void 0 : (_event$data$transStat = _event$data.transStatus) == null ? void 0 : _event$data$transStat.toUpperCase()
            });
            window.removeEventListener('message', messageHandler);
          }
        }

        window.addEventListener('message', messageHandler);
        var form = createForm('cReqForm', acsURL, iframeName, 'creq', base64EncodedcReqData);
        iframe.appendChild(form);
        form.submit();
        return iframe.contentWindow;
      };
      /** Create the iframe, then append the form
       * @returns {Promise<*>}
       */


      var createIframeAndAppendForm = () => {
        var iframe = createIframe(iframeConfig.container, iframeName, iframeSize[0], iframeSize[1]);
        iframe.setAttribute('width', '100%');
        return Promise.resolve(appendAndSubmitForm(iframe));
      };
      /** Call create iframe and
       * then return a status if a callback has been passed
       * in the createChallenge function.
       */


      createIframeAndAppendForm().then(iframe => {
        // TODO: Check with merchant with status updates are expected
        if (callback) {
          var _status = {
            status: 'challenge iframe created'
          }; // const style = document.createElement('style')
          // style.textContent = `
          //   body {
          //     width: 100%!important;
          //   }
          // `
          // ;(iframe as Window)?.contentDocument?.head.appendChild(style)

          callback(_status);
        }
      });
    });
  }
};
//# sourceMappingURL=get-challenge-iframe.js.map